import React, { useEffect, useState, useContext } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { AddorEditSubCompany, EditShops } from './Form';
import { getShops, deleteShops, getSubCompany, deleteSubCompany, BASE_URL } from '../../../Utility/Api';
import { WarehouseContext } from '../../../Utility/UserContext';
import { toast } from 'react-toastify';
import { Deletemodel } from '../../Common/Functions';
import { setLocalStorage } from '../../../Utility/function';

const SubCompany = () => {
  const navigate = useNavigate()
  const location = useLocation();
  const { state } = location;
  const [addoredit, setaddoredit] = useState();
  const [Shops, setShops] = useState();
  const [selectedShops, setSelectedShops] = useState(false);
  const [selectedBranch, setSelectedBranch] = useState({});
  const [ShowEditModal, setShowEditModal] = useState(false);
  const { shopItem, setShopItem, subCompany, setSubCompany } = useContext(WarehouseContext);
  const [deletemodel, showDeletemodel] = useState(false);
  const [deleteID, setDeleteID] = useState("");
  const [search, setSearch] = useState("");

  useEffect(() => {
    fetchShops()
  }, [])

  const fetchShops = async (page = 1, text = "") => {
    try {
      const response = await getSubCompany(page, text);
      if (response.data && response.data.data) {
        setShops(response.data.data);
      }
    } catch (error) {
      console.error('Error fetching category data:', error);
    }
  };

  const openAddModal = () => {
    setSelectedShops(false)
    setSelectedBranch()
    setaddoredit(true)
    setShowEditModal(!ShowEditModal)
  }

  const openEditModal = (cat) => {
    setaddoredit(false)
    setShowEditModal(!ShowEditModal)
  }

  const handledeleteModal = (ID) => {
    showDeletemodel(true);
    setDeleteID(ID);
  }

  const handleDelete = async () => {
    try {
      const deleteItem = await deleteSubCompany(deleteID);
      console.log(deleteItem);
      toast.success("Item Deleted successfully")
      await fetchShops();
      showDeletemodel(false)
    } catch (err) {
      console.error("Error deleting shop:", err);
    }
  };

  const defaultShop = {
    shop_title: "No Shop Selected"
  };

  const handleEdit = (shop) => {
    setaddoredit(false)

    const Payload = {
      id: shop.id,
      title: shop.title,
      Address: shop.Address,
      phone1: shop.phone1,
      phone2: shop.phone2,
      email: shop.email,
      branch_id: shop.branch_id,
      ...shop
    };

    setSelectedShops(Payload)
    setShowEditModal(!ShowEditModal)
  };

  return (
    <div className='container-fluid d-flex align-items-center' >
      <div className=" mt-4 mx-3 pb-5 w-100">
        <div className='d-flex w-100 justify-content-center'>
          <div className="col-4 position-relative" style={{ width: "30%" }}>
            <input
              type="text"
              className="form-control form-control-sm mt-4"
              placeholder="Search..."
              onChange={(e) => setSearch(e.target.value)}
            />
            <img
              src="/assets/images/icons/search.png"
              alt="Search Icon"
              style={{
                position: "absolute",
                right: "12px",
                top: "70%",
                transform: "translateY(-50%)",
                height: "18px",
                pointerEvents: "none",
              }}
            />
          </div>
        </div>

        <div className='d-flex justify-content-end my-4'>
          <button
            className='btn btn-primary py-1'
            onClick={() => openAddModal()}
          >
            Add Shop
          </button>
        </div>

        <div className="row">
          {Array.isArray(Shops) && Shops
            .filter((shop) => shop.title.toLowerCase().includes(search.toLowerCase())
            ).map((entity, index) => (
              <div className="col-12 col-md-4 col-lg-4 mb-2" key={index}>
                <div
                  className="card h-100 text-center"
                >
                  {entity?.title != "Top Tecno" && (
                    <div className='d-flex justify-content-end'>
                      <div className='mt-2 mx-3 text-end' role="button" onClick={() => handleEdit(entity)}>
                        <i class="fas fa-edit text-success"></i>
                      </div>
                      <div className='mt-2 mx-3 text-danger text-end' role="button" onClick={() => handledeleteModal(entity.id)}>
                        <i class="fas fa-trash text-danger"></i>
                      </div>
                    </div>
                  )}
                  <div
                    className="card-body d-flex flex-column align-items-center justify-content-center">
                    <img
                      src={entity.logo ? BASE_URL + entity.logo : '/assets/images/tech_logo.webp'}
                      style={{ width: "80px",height:"80px", maxHeight: "80px", objectFit: "contain", borderRadius: "5px" }}
                    ></img>
                    <h4 className="card-title mt-3">{entity.title}</h4>
                  </div>
                </div>
              </div>
            ))}
        </div>

        {deletemodel && (
          <Deletemodel
            setShowModal={() => showDeletemodel(false)}
            handleDelete={handleDelete}
          />
        )}

        <AddorEditSubCompany
          showModal={ShowEditModal}
          setShowModal={() => openEditModal()}
          fetchdata={() => fetchShops()}
          selectedShops={selectedShops}
          AddorEdit={addoredit}
        />
      </div>
    </div>
  )
}

export default SubCompany
